<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'financialIndex')">
            <!-- 财务管理 -->
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-date-picker v-decorator="['startTime', {initialValue: defaultValue}]" @change="onChangeDate"/>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="searchLoading" type="primary" @click="getList">筛选</a-button>
                        <a-button :loading="searchLoading" @click="handleReset()">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card v-if="shopId && shopId != -1">
                <div slot="extra">
                    <a-button type="primary" @click="exportExcel" :loading="searchLoading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </div>
                <div slot="title" class="text-primary">
                    {{this.shopName}}
                    <a-popover title="计算公式">
                        <template slot="content">
                            <div>应收=当日门店订单未使用任何优惠前的金额总和</div>
                            <div>折后应收=当日门店订单使用优惠券后的金额总和</div>
                            <div>当日退款=当日门店订单（当日已退款）金额总和</div>
                            <div>非当日退款=非当日门店订单（当日已退款）金额总和</div>
                            <div>应交/实收=折后应收-当日退款-非当日退款（特殊说明：pos机应交金额不扣除非当日退款）</div>
                            <div>实交=收银员在收银台交账金额</div>
                            <div>差异=应交-实交</div>
                        </template>
                        <a-icon type="info-circle" />
                    </a-popover>
                </div>
                <a-table
                bordered
                :dataSource="warehouse"
                :columns="columns"
                :pagination="false"
                :rowKey="(record,index) => index"
                :scroll="{x: 2440,y: 440}"
                :loading="searchLoading"
                >
                    <span v-if="getBtnByAuth('financialDetail')" slot="action" slot-scope="a,row">
                        <a v-if="row.cashier !== '总计'" class="text-primary" @click="toDetail(row)">明细</a>
                        <a class="text-primary"  @click="toDetail(row)" v-else>门店明细</a>
                    </span>
                </a-table>
            </a-card>
            <a-empty v-else>
                <span slot="description" class="font-big22">请切换到各门店查看</span>
            </a-empty>
            <report-export-modal ref="reportExportModal" :exportType="31"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment';
    import { mapMutations, mapGetters } from 'vuex';
    export default {
        name: 'financialIndex',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '收银员',
                    dataIndex: 'cashier',
                    width: 100,
                    fixed: 'left'
                },
                {
                    title: '收银交账',
                    dataIndex: 'action',
                    scopedSlots: { customRender: "action" },
                    width: 90,
                    fixed: 'left'
                },
                {
                    title: '收银票台',
                    dataIndex: 'platformName',
                    width: 90,
                    fixed: 'left'
                },
                {
                    title: '扫码枪',
                    children: [
                        {
                            title: '应收/元',
                            dataIndex: 'scannerincomeBeforeDiscount'
                        },
                        {
                            title: '折后应收/元',
                            dataIndex: 'scannerincomeAfterDiscount'
                        },
                        {
                            title: '当日退款/元',
                            dataIndex: 'scannerrefundToday'
                        },
                        {
                            title: '非当日退款/元',
                            dataIndex: 'scannerrefundNotToday'
                        },
                        {
                            title: '实收/元',
                            dataIndex: 'scannerdeliverReal'
                        },
                    ]
                },
                {
                    title: '现金',
                    children: [
                        {
                            title: '应收/元',
                            dataIndex: 'cashincomeBeforeDiscount'
                        },
                        {
                            title: '折后应收/元',
                            dataIndex: 'cashincomeAfterDiscount'
                        },
                        {
                            title: '当日退款/元',
                            dataIndex: 'cashrefundToday'
                        },
                        {
                            title: '非当日退款/元',
                            dataIndex: 'cashrefundNotToday'
                        },
                        {
                            title: '应交/元',
                            dataIndex: 'cashdeliverShould'
                        },
                        {
                            title: '实交/元',
                            dataIndex: 'cashdeliverReal'
                        },
                        {
                            title: '差异/元',
                            dataIndex: 'cashdeliverDiff'
                        },
                    ]
                },
                {
                    title: 'POS机',
                    children: [
                        {
                            title: '应收/元',
                            dataIndex: 'posincomeBeforeDiscount'
                        },
                        {
                            title: '折后应收/元',
                            dataIndex: 'posincomeAfterDiscount'
                        },
                        {
                            title: '当日退款/元',
                            dataIndex: 'posrefundToday'
                        },
                        {
                            title: '非当日退款/元',
                            dataIndex: 'posrefundNotToday'
                        },
                        {
                            title: '应交/元',
                            dataIndex: 'posdeliverShould'
                        },
                        {
                            title: '实交/元',
                            dataIndex: 'posdeliverReal'
                        },
                        {
                            title: '差异/元',
                            dataIndex: 'posdeliverDiff'
                        },
                    ]
                },
                {
                    title: '储值',
                    children: [
                        {
                            title: '应收/元',
                            dataIndex: 'balanceincomeBeforeDiscount'
                        },
                        {
                            title: '折后应收/元',
                            dataIndex: 'balanceincomeAfterDiscount'
                        },
                        {
                            title: '当日退款/元',
                            dataIndex: 'balancerefundToday'
                        },
                        {
                            title: '非当日退款/元',
                            dataIndex: 'balancerefundNotToday'
                        },
                        {
                            title: '实收/元',
                            dataIndex: 'balancedeliverReal'
                        },
                    ]
                },
                {
                    title: '后台操作',
                    children: [
                        {
                            title: '应收/元',
                            dataIndex: 'systemOperateincomeBeforeDiscount'
                        },
                        {
                            title: '折后应收/元',
                            dataIndex: 'systemOperateincomeAfterDiscount'
                        }
                    ]
                },
                {
                    title: '手工交账',
                    children: [
                        {
                            title: '实交/元',
                            dataIndex: 'manualdeliverReal'
                        }
                    ]
                }
            ];
            return {
                columns,
                warehouse: [],
                filterForm: this.$form.createForm(this),
                defaultValue: moment(),
                countData: {},
                searchLoading: false
            };
        },
        beforeCreate() {},
        watch: {
            shopName(val,oVal) {
                this.getList();
            },
        },
        computed: {
            ...mapGetters(['shopName','shopId'])
        },
        methods: {
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            onChangeDate() {
                setTimeout(() => {
                    this.getList()
                },100)
            },
            //获取列表
            getList() {
                if(!Boolean(this.shopId) || this.searchLoading) {
                    return false;
                }
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.startTime = values.startTime ? values.startTime.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                    this.searchLoading = true;
                    this.$api.financial.financeList({ query: {
                        shopId: this.shopId,
                        date: values.startTime
                    } }).then(res => {
                        this.searchLoading = false;
                        this.warehouse = [];
                        let names = ['pos','balance','cash','manual','scanner','systemOperate'];
                        let cashierId = [];
                        res.forEach(item => {
                            let obj = {};
                            names.forEach(o => {
                                obj = Object.assign(obj,{
                                    [o + 'deliverDiff']: item[o].deliverDiff === null ? '/' : item[o].deliverDiff === 0 ? 0 : item[o].deliverDiff.toFixed(2),
                                    [o + 'deliverReal']: item[o].deliverReal === null ? '/' : item[o].deliverReal === 0 ? 0 : item[o].deliverReal.toFixed(2),
                                    [o + 'deliverShould']: item[o].deliverShould === null ? '/' : item[o].deliverShould === 0 ? 0 : item[o].deliverShould.toFixed(2),
                                    [o + 'incomeAfterDiscount']: item[o].incomeAfterDiscount === null ? '/' : item[o].incomeAfterDiscount === 0 ? 0 : item[o].incomeAfterDiscount.toFixed(2),
                                    [o + 'incomeBeforeDiscount']: item[o].incomeBeforeDiscount === null ? '/' : item[o].incomeBeforeDiscount === 0 ? 0 : item[o].incomeBeforeDiscount.toFixed(2),
                                    [o + 'refundNotToday']: item[o].refundNotToday === null ? '/' : item[o].refundNotToday === 0 ? 0 : item[o].refundNotToday.toFixed(2),
                                    [o + 'refundToday']: item[o].refundToday === null ? '/' : item[o].refundToday === 0 ? 0 : item[o].refundToday.toFixed(2),
                                })
                            })
                            item.cashierId ? cashierId.push(item.cashierId) : cashierId.push('-1');
                            obj = Object.assign(obj,{
                                cashier: item.cashier,
                                cashierId: item.cashierId || cashierId.join(','),
                                platformId: item.platformId,
                                platformName: item.platformName,
                                recordDate: this.filterForm.getFieldValue('startTime').format('YYYY-MM-DD')
                            })
                            this.warehouse.push(obj)
                        })
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                })
            },

            // 导出excel
            exportExcel() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.startTime = values.startTime ? values.startTime.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                    this.searchLoading = true
                    this.$api.financial.refundExport({ query: {
                        shopId: this.shopId,
                        date: values.startTime
                    } }).then(res => {
                        this.openExportModal();
                        this.searchLoading = false;

                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            },
            /**
             * @count 财务统计
             */
            count(startTime) {
                if(!Boolean(this.shopId)) {
                    return false;
                }
                this.$api.financial.count({
                    params: {
                        shopId: this.shopId,
                        date: startTime
                    }
                }).then(res => {
                    this.countData = res;
                });
            },
            toRecord() {
                this.$router.push({path:'operationRecord'})
            },
            toDetail(row) {
                this.$router.push({
                    path:'financialDetail',
                    query:{
                        date: this.filterForm.getFieldValue('startTime').format('YYYY-MM-DD'),
                        cashierId: row.cashierId,
                        cashier: row.cashier,
                        shopName: this.shopName,
                        platformId: row.platformId || '-1',
                        platformType: 3
                    }
                })
            }
        },
        created() {},
        mounted() {
            this.getList();
        }
    };
</script>
<style lang="scss">
    .my-divider {
        margin: 8px 0!important;
    }
</style>
